export default __webpack_public_path__ + "locales/ja-JP/DataReassignmentDialog.json?hash=cb71a9c00a3f1404d7e706943e640ae6";